import axios from "axios";

export const fetchForm = async (key) => {
    return axios({
        method: "GET",
        url: `application-form`,
        params: {
            key,
        },
    })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.error("Failed to get form info");
            console.error(error);
        });
};

export const submitForm = async (key, data) => {
    return axios({
        method: "POST",
        url: `application-form`,
        data: {
            key,
            ...data,
        },
    })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.error("Failed to submit the form");
            console.error(error);
            return error;
        });
};

export const fetchCountries = async (userId) => {
    return axios
        .get(`/common/countries`, {
            params: {
                userId,
            },
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.error("Failed to fetch countries");
            console.error(error);
        });
};
